import { render, staticRenderFns } from "./allorders.vue?vue&type=template&id=7d59ac47&"
import script from "./allorders.vue?vue&type=script&lang=js&"
export * from "./allorders.vue?vue&type=script&lang=js&"
import style0 from "./allorders.vue?vue&type=style&index=0&id=7d59ac47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports